<app-breadcrumb [master]="'Należności'" [parentName]="'Przelewy'" [name]="'Lista'"></app-breadcrumb>
<div class="transfer-list-container">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="transfers-list-filters">
      <ng-container>
        <mat-form-field class="transfer-list-filter">
          <mat-label>Nazwa odbiorcy</mat-label>
          <input matInput placeholder="" name="contains$name" [(ngModel)]="initialFilters.contains$name">
        </mat-form-field>

        <mat-form-field class="transfer-list-filter">
          <mat-label>Numer rachunku bankowego</mat-label>
          <input matInput placeholder="" name="contains$accountNumber"
                 [(ngModel)]="initialFilters.contains$accountNumber">
        </mat-form-field>
        <mat-form-field class="transfer-list-filter">
          <mat-label>Kwota przelewu od</mat-label>
          <input matInput placeholder="" name="gte$transferAmount" [(ngModel)]="initialFilters.gte$transferAmount">
        </mat-form-field>
        <mat-form-field class="transfer-list-filter">
          <mat-label>Kwota przelewu do</mat-label>
          <input matInput placeholder="" name="lte$transferAmount" [(ngModel)]="initialFilters.lte$transferAmount">
        </mat-form-field>

        <mat-form-field class="transfer-list-filter">
          <mat-label>Tytuł przelewu</mat-label>
          <input matInput placeholder="" name="contains$transferTitle" [(ngModel)]="initialFilters.contains$transferTitle">
        </mat-form-field>

      </ng-container>
    </form>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" style="margin-bottom: 15px">

    <button *ngIf="generate && (userPermissions | async)?.receivables.delete && totalDataAll>0" (click)="generateFile()" class="report-button" mat-raised-button color="primary">
      <mat-icon>add</mat-icon>
      <span> Generuj plik do banku</span></button>
    <span fxFlex></span>
    <div>
      <app-detail *ngIf="generate" style="position: relative; top: -1px" header="Liczba przelewów do zrealizowania" [value]="totalDataAll.toString()"></app-detail>
    </div>
    <span fxFlex></span>

    <button *ngIf="(userPermissions | async).receivables.delete" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.delete" mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">


    <table mat-table [dataSource]="receivablesTransfers" matSort (matSortChange)="sortChanged($event)" [trackBy]="trackTask">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nazwa odbiorcy</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link"
             [routerLink]="['/naleznosci/przelewy/szczegoly', element.uuid]">{{ element.name }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="transferTitle">
        <th mat-header-cell *matHeaderCellDef > Tytuł przelewu</th>
        <td mat-cell *matCellDef="let element">
          {{ element.transferTitle }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accountNumber">
        <th mat-header-cell *matHeaderCellDef > Numer konta</th>
        <td mat-cell *matCellDef="let element">
          {{ element.accountNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="transferAmount"> Kwota</th>
        <td mat-cell *matCellDef="let element">
          {{ element.transferAmount + " " + "zł" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef > Status</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.status.color + '-button'">{{ element.status.name }}</button>
        </td>
      </ng-container>


      <ng-container matColumnDef="createAd">
        <th mat-header-cell *matHeaderCellDef > Data dodania</th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'yyyy-MM-dd' }}
        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
